import { WalletWeb } from "./web";
import { WalletBlockProps } from "./types";

export function WalletWebEditor(props: WalletBlockProps) {
  return <WalletWeb {...props} />;
}
